import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { BaseComponent } from '../../../../core/layout/components/abstracts/base.component';
import { ConfirmationDirective } from '../../../../shared/directives/confirmation.directive';
import { TooltipDirective } from '../../../../shared/directives/tooltip.directive';
import { TranslatePipe } from '../../../../shared/pipes/trans.pipe';
import { EmptyPipe } from '../../../../shared/pipes/empty.pipe';
import { LocaleDatetimeFormatPipe } from '../../../../shared/pipes/locale-datetime-format.pipe';
import { LocaleDateFormatPipe } from '../../../../shared/pipes/locale-date-format.pipe';
import { ICard } from '../../core/interfaces/ICard';
import { CardsService } from '../../core/services/CardsService';
import { ApiErrorResponse } from '../../../../core/classes/ApiErrorResponse';
import { AddFreeEntryModalComponent } from '../../modals/add-free-entry-modal/add-free-entry-modal.component';
import { ICardFreeEntryItem } from '../../core/interfaces/ICardFreeEntryItem';
import { ArrayFilterPipe } from '../../../../shared/pipes/array-filter.pipe';
import { SwitchComponent } from '../../../../shared/components/switch/switch.component';
import { FormsModule } from '@angular/forms';
import { ArraySortByKeyPipe } from '../../../../shared/pipes/array-sort-by-key.pipe';

@Component({
  selector: 'app-card-free-entries-table',
  standalone: true,
  imports: [
    ConfirmationDirective,
    TooltipDirective,
    TranslatePipe,
    EmptyPipe,
    LocaleDatetimeFormatPipe,
    LocaleDateFormatPipe,
    AddFreeEntryModalComponent,
    ArrayFilterPipe,
    SwitchComponent,
    FormsModule,
    ArraySortByKeyPipe,
  ],
  templateUrl: './card-free-entries-table.component.html',
  styleUrl: './card-free-entries-table.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardFreeEntriesTableComponent extends BaseComponent {

  @Input({ required: true }) card: ICard;

  @Output() cardUpdated = new EventEmitter<ICard>();

  public showUsedItems = false;
  public readonly excludeUsedItems = (x: ICardFreeEntryItem) => !!!x.dateUsed;
  public readonly excludeUnusuedItems = (x: ICardFreeEntryItem) => !!x.dateUsed;

  private readonly _cardsService = inject(CardsService)

  public deleteFreeEntryFromCard(freeEntryId: number): void {
    this._cardsService.deleteFreeEntryFromCard(this.card.cardId, freeEntryId)
      .pipe()
      .subscribe({
        next: res => this.cardUpdated.emit(res.data),
        error: ({ error }: ApiErrorResponse) => {
          this.notificationService.pushError(
            'Fehler'.trans('notifications/error.Title'),
            error.message.trans(`delete-free-entry-from-card/notifications/${error.message}.Message`)
          );
        }
      });
  }
}
